module.exports = __webpack_public_path__ + "media/svgs/line-vertical-2a4c224a503766ca7ec6396e0398c844.svg";